import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticateserviceService } from '../_service/authenticateservice.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginPromptComponent } from '../_component/sharedComponents/login-prompt/login-prompt.component';
import { DeviceService } from '../_service/tv-detect.service';

@Injectable({ providedIn: 'root' })
export class RegisteredUserGuard implements CanActivate {
  constructor(
    private authService: AuthenticateserviceService,
    private router: Router,
    private dialog: MatDialog,
    private device: DeviceService
  ) {}

  canActivate(): boolean {
    if (!this.authService.isGuest()) {
      return true;
    }
    this.dialog.open(LoginPromptComponent, {
      panelClass: 'login-prompt-dialog',
      data: { message: 'Login or Create a Free Account to access this feature' },
      disableClose: this.device.isTV()
    });
    return false;
  }
}
